var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M640 2560 l0 -1920 1920 0 1920 0 0 1920 0 1920 -1920 0 -1920 0 0 -1920z m3630 0 l0 -1710 -1710 0 -1710 0 0 1710 0 1710 1710 0 1710 0 0 -1710z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2367 3715 c-367 -62 -690 -303 -861 -643 -70 -139 -116 -342 -116 -512 0 -313 121 -603 344 -826 315 -315 769 -423 1194 -285 355 116 646 415 752 772 69 231 65 486 -10 711 -100 298 -329 555 -614 689 -208 97 -463 132 -689 94z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeg);
export default __webpack_public_path__ + "static/media/veg.3c88ab36deb9c0f32801e0871ecd42c7.svg";
export { ForwardRef as ReactComponent };